export default "__VITE_ASSET__DyNMXy99__"